import {
  collection,
  doc,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore/lite";
import { db, auth } from "../../Firebase";
import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  List,
  ListItem,
  Slide,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import LogoutIcon from "@mui/icons-material/Logout";
import LoginIcon from "@mui/icons-material/Login";
import EditIcon from "@mui/icons-material/Edit";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ShopGroup = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [editGroup, setEditGroup] = useState({
    members: [],
  });
  const [groups, setGroups] = useState([]);
  const [newMember, setNewMember] = useState("");
  const [newGroup, setNewGroup] = useState({
    name: "",
  });

  const location = useLocation();
  const [email, setEmail] = useState("");

  const handleClose = () => {
    setOpen(false);
    setNewMember("");
  };
  const logout = () => {
    auth.signOut();
    console.log(location.pathname);
    navigate("/auth");
  };

  useEffect(() => {
    auth.onAuthStateChanged((state) => {
      if (state !== null) {
        setEmail(state.email);
      }
    });
  }, []);

  const fetchGroups = useCallback(async () => {
    const groupCollection = collection(db, "shop_groups");
    const groupSnapshot = await getDocs(groupCollection);
    var groupList = groupSnapshot.docs.map((doc) => {
      const data = doc.data();
      data.id = doc.id;
      return data;
    });
    console.log("groups", groupList);
    groupList = groupList.filter(
      (g) => g.owner === email || g.members?.includes(email)
    );
    setGroups(groupList);
    console.log("filtered groups", groupList);
    return groupList;
  }, [email]);

  const addGroup = async (group) => {
    group = {
      ...group,
      owner: auth.currentUser?.email,
    };
    console.log("group added", group);
    const groupCollection = collection(db, "shop_groups");
    addDoc(groupCollection, group).then((result) => {
      console.log("group added", result);
      fetchGroups();
    });
  };
  const updateGroup = async (group) => {
    console.log("group update", group);
    const groupRef = doc(db, `shop_groups/${group.id}`);
    updateDoc(groupRef, group).then((result) => {
      console.log("group updated", result);
      fetchGroups();
    });
  };
  const deleteGroup = async (groupId) => {
    const docRef = doc(db, `shop_groups/${groupId}`);
    deleteDoc(docRef).then((result) => {
      console.log("deleted group", result);
      fetchGroups();
    });
  };

  useEffect(() => {
    fetchGroups().then((result) => setGroups(result));
  }, [email, fetchGroups]);

  return (
    <>
      <Stack direction="row" justifyContent={"end"} padding={2}>
        <Typography width={"100%"} fontWeight="bold" justifyContent={"center"} variant="body">
          {email}
        </Typography>
        {location.pathname !== "auth" ? (
          email === "" ? (
            <Button variant="contained" onClick={() => navigate("/auth")}>
              <LoginIcon style={{ padding: "5px" }} /> Login
            </Button>
          ) : (
            <Button variant="contained" onClick={logout}>
              <LogoutIcon style={{ padding: "5px" }} /> Logout
            </Button>
          )
        ) : null}
      </Stack>
      <Grid container justifyContent="center" minWidth={"400px"}>
        <Stack minWidth={"400px"}>
          <Stack spacing={2} padding={2}>
            <TextField
              id="outlined-basic"
              label="Group Name"
              variant="outlined"
              type="text"
              value={newGroup.name}
              onChange={(event) =>
                setNewGroup({
                  ...newGroup,
                  name: event.target.value,
                })
              }
            />
            <Button variant="contained" onClick={() => addGroup(newGroup)}>
              Add Group
            </Button>
          </Stack>
          <List>
            {Array.isArray(groups) &&
              groups?.map((group) => (
                <Card key={group.id} variant="outlined">
                  <ListItem
                    key={group.id}
                    xs={12}
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate(`/groups/${group.id}`)}
                  >
                    <Box
                      key={group.id}
                      width="100%"
                      display="flex"
                      alignItems={"center"}
                      justifyContent={"space-between"}
                    >
                      <h3>{group.name}</h3>
                      <IconButton
                        aria-label="edit"
                        color="primary"
                        onClick={(e) => {
                          e.stopPropagation();
                          setEditGroup({
                            ...group,
                            members:
                              group.members === undefined ? [] : group.members,
                          });
                          setOpen(true);
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                    </Box>
                  </ListItem>
                </Card>
              ))}
          </List>
        </Stack>
        <Dialog
          fullWidth
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>Edit "{editGroup.name}"</DialogTitle>
          <DialogContent>
            <Stack spacing={2} p={5}>
              <TextField
                id="outlined-basic"
                label="Name"
                variant="outlined"
                type="text"
                InputLabelProps={{ shrink: true }}
                value={editGroup.name}
                onChange={(event) => {
                  setEditGroup({
                    ...editGroup,
                    name: event.target.value,
                  });
                }}
              />
              <TextField
                id="outlined-basic"
                label="Member"
                variant="outlined"
                type="email"
                InputLabelProps={{ shrink: true }}
                value={newMember}
                onChange={(event) => {
                  setNewMember(event.target.value);
                }}
              />
              <Button
                aria-label="add member"
                color="primary"
                onClick={() => {
                  if (newMember !== "") {
                    setEditGroup({
                      ...editGroup,
                      members: [newMember].concat(editGroup.members),
                    });
                  }
                  console.log(editGroup);
                }}
              >
                <PersonAddIcon style={{ padding: "5px" }} /> Add
              </Button>
              <List>
                <ListItem>
                  {editGroup.owner}
                  <Chip label="Owner" color="primary" style={{marginLeft:"5px"}}/>
                </ListItem>
                {editGroup.members.map((member, idx) => (
                  <Stack direction="row" justifyContent={"space-between"}>
                    <ListItem key={idx}>{member}</ListItem>
                    {editGroup.owner === email && (
                      <IconButton
                        aria-label="delete"
                        color="error"
                        onClick={() => {
                          editGroup.members.splice(idx, 1);
                          setEditGroup({
                            ...editGroup,
                            members: [].concat(editGroup.members),
                          });
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </Stack>
                ))}
              </List>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Stack
              direction={"row"}
              justifyContent="end"
              spacing={2}
              padding={3}
            >
              {email === editGroup.owner && (
                <Button
                  aria-label="delete"
                  color="error"
                  onClick={() => {
                    deleteGroup(editGroup.id);
                    setOpen(false);
                  }}
                >
                  <DeleteIcon /> Delete
                </Button>
              )}
              <Button onClick={handleClose}>Cancel</Button>
              <Button
                onClick={() => {
                  updateGroup(editGroup);
                  setOpen(false);
                }}
              >
                Update
              </Button>
            </Stack>
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
};

export default ShopGroup;
